import { Button } from './deprecated-button'

import type { ButtonProps, ButtonSize, ButtonVariant } from './deprecated-button'

export type { ButtonProps, ButtonSize, ButtonVariant }
export default Button
